/* eslint-disable no-underscore-dangle */
import {fromJS, Map} from 'immutable';

import QuestionTypeStore from 'components/QuestionTypes/QuestionType.store';
import {GuessModel} from 'resources/Guess/Guess.model';

import freeEntryQuestionActions from './FreeEntryQuestion.actions';

export default class FreeEntryQuestionStore extends QuestionTypeStore {
  constructor(name, questionId, question) {
    super(name);

    this.initialData = fromJS({
      ...this.draftGuessInitialData,
      inputValues: {},
      openTopFive: [],
      questionId,
      shouldShowExplanation: false
    });

    this.setInitialData(this.initialData);
    this.writeData('__question', question);

    this.handleTargeted(freeEntryQuestionActions.UPDATE_INPUT, this._updateInput);
  }

  afterLoadDraftGuess(draftGuess) {
    this.writeData('inputValues', this.parseGuess(draftGuess));
  }

  buildCorrectGuess(question) {
    const validResponse = question.getValidResponse();

    return new GuessModel({
      content: validResponse ? validResponse.map((val) => val.first()) : new Map(),
      correct: true,
      rubric: question.getMeta().getQuestionRubric(),
      solutionText: question.getSolutionText(),
      pointsPossible: question.getPoints(),
      pointsEarned: question.getPoints(),
      question
    });
  }

  buildGuessContent() {
    const guessContent = this.readData('inputValues');
    if (!guessContent) {
      return {};
    }
    return guessContent.map((value) => value.trim()).toJS();
  }

  _clearGuess() {
    super._clearGuess();

    this.writeData('inputValues', this.initialData.get('inputValues'));
    super.kickoffDebouncedSaveDraftGuess();
  }

  getValueForId(inputId) {
    return this.readData(['inputValues', inputId]);
  }

  _loadGuess(guess) {
    super._loadGuess(guess);

    this.writeData('inputValues', this.parseGuess(guess));
  }

  parseGuess(guess) {
    const content = guess?.get?.('content');
    return content || new Map();
  }

  _updateInput({inputId, value}) {
    this.writeData((store) => store.setIn(['inputValues', inputId], value));
    super.kickoffDebouncedSaveDraftGuess();
  }
}
